import { render, staticRenderFns } from "./AdministracionLicencias.vue?vue&type=template&id=9f5f1ebc"
import script from "./AdministracionLicencias.vue?vue&type=script&lang=js"
export * from "./AdministracionLicencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports